class CommonHelper {
  static addDolarSign(value: number, fractionDigits: number = 2) {
    const formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    });

    if (value < 0) {
      return `-$${formatter.format(Math.abs(value))}`;
    }

    return `$${formatter.format(value)}`;
  }

  static safeText = (
    value: string | null | undefined,
    fallback: string = "-"
  ) => {
    return value && value.trim() !== "" ? value : fallback;
  };

  static validateEmail = (email: string): boolean => {
    const emailPattern =
      /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

    return emailPattern.test(email);
  };

  static validatePhone = (phoneNumber: string): boolean => {
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;

    return phoneRegex.test(phoneNumber);
  }

  static normalizedPhone = (phone: string) => {
    return phone.replace(/\D/g, "");
  };

  static formatPhone334 = (value: string) => {
    const digits = value.replace(/\D/g, "").slice(0, 10);
    const p1 = digits.slice(0, 3);
    const p2 = digits.slice(3, 6);
    const p3 = digits.slice(6, 10);
    if (digits.length <= 3) return p1;
    if (digits.length <= 6) return `${p1}-${p2}`;
    return `${p1}-${p2}-${p3}`;
  };
}

export default CommonHelper;
